import { observer } from "mobx-react";
import React, { useState } from "react";
import classNames from "classnames";

export interface IGraphProps {
	home?: string;
	away?: string;
	info?: string;
	removeValues?: boolean;
	graphName?: string;
	className?: string;
	data?: {
		home?: string;
		away?: string;
		homeValue?: number;
		awayValue?: number;
	};
	matchNames?: {
		home?: string;
		away?: string;
	};
	max?: number;
	maxHome?: number;
	maxAway?: number;
	isPercentage?: boolean;
	isTotalGraph?: boolean;
	highlightTeam?: { homeTeamHighlight: boolean; awayTeamHighlight: boolean };
	isNotUnique?: boolean;
}

export default observer(function EventStatsGraph(props: IGraphProps) {
	if (props.data?.homeValue == null && props.data?.awayValue == null) {
		return null;
	}

	return (
		<>
			<div className="card--stats__section">
				<InfoSection {...props} />

				<div
					className="card--stats__row"
					data-at="at-EventStatsGraph__row--chart"
				>
					<div className="card--stats__col card--stats__col--left">
						<div className="chart chart--left is-home">
							{!props.removeValues && (
								<label
									htmlFor="chartHome"
									className="chart__value"
								>
									{props.data?.homeValue}
									{props.isPercentage && <span>%</span>}
								</label>
							)}

							<progress
								id="chartHome"
								className={classNames("chart__progress", {
									"is-transparent":
										props.highlightTeam?.awayTeamHighlight,
								})}
								value={
									props.isTotalGraph
										? 100
										: props.data?.homeValue || 0
								}
								max={props?.max || props?.maxHome || 100}
							/>
						</div>
					</div>

					<div className="card--stats__col card--stats__col--right">
						<div className="chart chart--right is-away">
							{!props.removeValues && (
								<label
									htmlFor="chartAway"
									className="chart__value"
								>
									{props.data?.awayValue}
									{props.isPercentage && <span>%</span>}
								</label>
							)}

							<progress
								id="chartAway"
								className={classNames("chart__progress", {
									"is-transparent":
										props.highlightTeam?.homeTeamHighlight,
								})}
								value={
									props.isTotalGraph
										? 100
										: props.data?.awayValue || 0
								}
								max={props?.max || props?.maxAway || 100}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
});

const InfoSection = (props: IGraphProps) => {
	const [showInfoSection, setShowInfoSection] = useState(false);

	return (
		<>
			<div
				className="card--stats__row"
				data-at="at-EventStatsGraph__row--info"
			>
				<div className="card--stats__col card--stats__col--left">
					<div className="card--stats__value">
						{props.data?.home || (
							<>
								{props.data?.home || props.data?.homeValue}
								{props.isPercentage && <>%</>}
							</>
						)}
					</div>
				</div>

				<div className="card--stats__col card--stats__col--middle card--stats__col--grow">
					{props.info ? (
						<div
							className="card--stats__title"
							onClick={() => setShowInfoSection(!showInfoSection)}
							role="button"
							aria-expanded={showInfoSection}
							aria-controls="graphAdditionalInfo"
						>
							{props.graphName && (
								<div className="card--stats__label">
									{props.graphName}
								</div>
							)}

							<i
								className={classNames(
									"card--stats__info u-icon u-icon--xsml",
									{
										"u-icon--info-circle u-color--text--tertiary":
											!showInfoSection,
										"u-icon--info-circle--bold is-expanded":
											showInfoSection,
									}
								)}
							/>
						</div>
					) : (
						<div className="card--stats__title">
							{props.graphName && (
								<div className="card--stats__label">
									{props.graphName}
								</div>
							)}
						</div>
					)}
				</div>

				<div className="card--stats__col card--stats__col--right">
					<div className="card--stats__value">
						{props.data?.away || (
							<>
								{props.data?.away || props.data?.awayValue}
								{props.isPercentage && <>%</>}
							</>
						)}
					</div>
				</div>
			</div>

			{showInfoSection && (
				<div
					id="graphAdditionalInfo"
					className="message message--sml message--info u-mar--top--2 u-mar--bottom--3 u-type--xsml"
				>
					{props.info}
				</div>
			)}
		</>
	);
};
